import React from 'react';
import { Card } from 'app/javascript/components/ui/card';
import { Skeleton } from 'app/javascript/components/ui/skeleton';
import { Empty, EmptyHeader, EmptyTitle, EmptyDescription } from 'app/javascript/components/ui/empty';

interface AdminPanelBodyProps {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  emptyMessage: string;
  children: React.ReactNode;
}

interface AdminPanelProps extends AdminPanelBodyProps {
  // Optional: when the panel lives inside a tab, the tab label is the title.
  title?: string;
}

function panelBody({ isLoading, isError, isEmpty, emptyMessage, children }: AdminPanelBodyProps) {
  if (isLoading) {
    return (
      <div className="space-y-3 p-5">
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-11/12" />
        <Skeleton className="h-5 w-4/5" />
      </div>
    );
  }

  if (isError) {
    return (
      <p className="p-5 text-sm text-red-400">
        Não foi possível carregar os dados. Tente novamente mais tarde.
      </p>
    );
  }

  if (isEmpty) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyTitle>Nada por aqui</EmptyTitle>
          <EmptyDescription>{emptyMessage}</EmptyDescription>
        </EmptyHeader>
      </Empty>
    );
  }

  return <div className="overflow-x-auto">{children}</div>;
}

// Shared shell for the /admin panels: section heading plus a card that owns
// the loading / error / empty states, so each table only renders its rows.
export default function AdminPanel({ title, ...bodyProps }: AdminPanelProps) {
  return (
    <section className="space-y-3">
      {title && <h2 className="font-bebas text-2xl tracking-wide text-foreground">{title}</h2>}
      <Card className="overflow-hidden py-0">{panelBody(bodyProps)}</Card>
    </section>
  );
}
